import type { Timestamp } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface TimestampEditorProps {
  label: string;
  value?: Timestamp;
  onChange: (value: Timestamp | undefined) => void;
  className?: string;
}

function timestampToDate(t?: Timestamp): string {
  if (!t || !t.seconds || t.seconds === "0") return "";
  const ms = parseInt(t.seconds) * 1000 + Math.floor(t.nanos / 1000000);
  const d = new Date(ms);
  return d.toISOString().slice(0, 16);
}

function dateToTimestamp(dateStr: string): Timestamp {
  const d = new Date(dateStr);
  const seconds = Math.floor(d.getTime() / 1000);
  const nanos = (d.getTime() % 1000) * 1000000;
  return { seconds: String(seconds), nanos };
}

export function TimestampEditor({ label, value, onChange, className }: TimestampEditorProps) {
  const dateVal = timestampToDate(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (!val) {
      onChange(undefined);
      return;
    }
    onChange(dateToTimestamp(val));
  };

  const handleClear = () => {
    onChange(undefined);
  };

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-1.5">
        <Label className="text-xs text-overlay1">{label}</Label>
        {value && value.seconds !== "0" && (
          <button
            type="button"
            onClick={handleClear}
            className="text-xs text-overlay0 hover:text-red transition-colors"
          >
            clear
          </button>
        )}
      </div>
      <Input
        type="datetime-local"
        value={dateVal}
        onChange={handleChange}
        className="[color-scheme:dark] pr-9"
      />
    </div>
  );
}
